import React from "react";
import Navbar from "../components/Navbar";
import "../css/PolicyPages.css";
import "../css/global.css";
import { useContacts } from "../context/ContactsContext";

// Last updated date for this policy
const LAST_UPDATED = "21/11/2025";

const PrivacyPolicy = () => {
  const { contacts } = useContacts();

  return (
    <div className="policy-page">
      <Navbar />
      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <div className="policy-content">
          <p className="last-updated">Ultimo aggiornamento: {LAST_UPDATED}</p>

          <section>
            <h2>1. Introduzione</h2>
            <p>
              {contacts.COMPANY_NAME} (di seguito "noi", "ci" o "nostro") rispetta la tua privacy e si impegna a proteggere i tuoi dati personali. 
              Questa Privacy Policy descrive come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali quando visiti il nostro sito web.
            </p>
          </section>

          <section>
            <h2>2. Titolare del Trattamento</h2>
            <p>
              Il Titolare del Trattamento dei dati personali è:<br/>
              <strong>{contacts.COMPANY_NAME}</strong><br/>
              Sede legale: {contacts.ADDRESS_LINE}, {contacts.ADDRESS_CITY}<br/>
              Email: {contacts.CONTACT_EMAIL}
            </p>
          </section>

          <section>
            <h2>3. Dati Raccolti</h2>
            <p>
              Il nostro sito web non utilizza cookie di tracciamento o di profilazione. I dati che potremmo raccogliere includono:
            </p>
            <ul>
              <li><strong>Dati di navigazione:</strong> Il tuo browser web trasmette automaticamente alcuni dati (indirizzo IP, tipo di browser, sistema operativo, pagine visitate) necessari per il funzionamento tecnico del sito.</li>
              <li><strong>Dati forniti volontariamente:</strong> Se ci contatti tramite i moduli presenti sul sito, raccogliamo solo i dati che ci fornisci volontariamente (nome, email, messaggio).</li>
            </ul>
          </section>

          <section>
            <h2>4. Finalità del Trattamento</h2>
            <p>I tuoi dati personali sono trattati per le seguenti finalità:</p>
            <ul>
              <li>Fornire i servizi richiesti e rispondere alle tue richieste di informazioni;</li>
              <li>Garantire la sicurezza e il corretto funzionamento del sito web;</li>
              <li>Adempiere agli obblighi di legge.</li>
            </ul>
          </section>

          <section>
            <h2>5. Base Giuridica del Trattamento</h2>
            <p>Il trattamento dei tuoi dati personali si basa su:</p>
            <ul>
              <li>Il tuo consenso esplicito per le attività di contatto;</li>
              <li>L'esecuzione di misure precontrattuali adottate su tua richiesta;</li>
              <li>Il legittimo interesse del titolare per garantire la sicurezza del sito.</li>
            </ul>
          </section>

          <section>
            <h2>6. Condivisione dei Dati</h2>
            <p>
              I tuoi dati personali non sono venduti, scambiati o trasferiti a terze parti senza il tuo consenso, 
              salvo quanto necessario per fornire i servizi richiesti o per adempiere agli obblighi di legge.
            </p>
          </section>

          <section>
            <h2>7. Conservazione dei Dati</h2>
            <p>
              I tuoi dati personali sono conservati per il tempo strettamente necessario alle finalità per le quali sono stati raccolti, 
              nel rispetto delle normative vigenti.
            </p>
          </section>

          <section>
            <h2>8. I Tuoi Diritti</h2>
            <p>Ai sensi del GDPR (Regolamento UE 2016/679), hai il diritto di:</p>
            <ul>
              <li>Accedere ai tuoi dati personali;</li>
              <li>Richiedere la rettifica o la cancellazione dei tuoi dati;</li>
              <li>Limitare o opporti al trattamento dei tuoi dati;</li>
              <li>Richiedere la portabilità dei dati;</li>
              <li>Revocare il consenso in qualsiasi momento;</li>
              <li>Presentare un reclamo all'autorità di controllo competente (Garante per la protezione dei dati personali).</li>
            </ul>
            <p>
              Per esercitare i tuoi diritti, puoi contattarci all'indirizzo email: <a href={`mailto:${contacts.CONTACT_EMAIL}`} className="link">{contacts.CONTACT_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>9. Sicurezza dei Dati</h2>
            <p>
              Adottiamo misure di sicurezza tecniche e organizzative adeguate per proteggere i tuoi dati personali 
              da accessi non autorizzati, perdita, distruzione o divulgazione.
            </p>
          </section>

          <section>
            <h2>10. Modifiche alla Privacy Policy</h2>
            <p>
              Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
            </p>
          </section>

          <section>
            <h2>11. Contatti</h2>
            <p>
              Per qualsiasi domanda o richiesta riguardante questa Privacy Policy, puoi contattarci a:<br/>
              Email: <a href={`mailto:${contacts.CONTACT_EMAIL}`} className="link">{contacts.CONTACT_EMAIL}</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
